<template>
  <div class="register-emails">
    <div class="form-register-emails">
      <img alt="Logo of DeStore" src="../assets/logo.svg" class="logo" />
      <h1 class="title"><span class="title-light">De</span>Store.</h1>
      <section class="body-form">
        <p class="info-destore">
          Destore is a place where decentralised applications become visible.
          Users can create publications about their decentralised applications,
          comment on other users' publications and search for new applications,
          all in a decentralised way.
        </p>
        <br />
        <p class="info-destore">
          If you want to be part of our community, leave your email down below
          and we will contact you when we launch!
        </p>
        <request-email-form class="emails-form" />
      </section>
    </div>
    <img
      alt="image of landing page"
      class="landing-image"
      src="../assets/landing-asset.svg"
    />
  </div>
</template>

<script>
import Vue from "vue";
import RequestEmailForm from "../components/RequestEmailForm.vue";

export default Vue.extend({
  name: "RequestEmails",
  components: {
    RequestEmailForm,
  },
});
</script>

<style scoped>
.title {
  font-family: stolzl, sans-serif;
  font-size: 5rem;
  color: #20273e;
  margin: 0 !important;
  padding: 0;
}
.body-form {
  margin-right: 50%;
  text-align: justify;
}
.form-register-emails {
  margin-left: 4%;
  margin-top: 4%;
  text-align: left;
  overflow-y: hidden !important;
}

.info-destore {
  font-family: montserrat, sans-serif;
  color: #20273e;
}

.logo {
  width: 5%;
  height: 5%;
  margin-bottom: 2%;
}

.title-light {
  font-weight: lighter;
  color: #948dbe;
}

.landing-image {
  position: absolute;
  top: -24%;
  right: -45%;
  width: 140%;
  height: 140%;
  z-index: -1;
}

.register-emails {
  position: relative;
  overflow: hidden;
  height: 100vh;
}
</style>
